import React from 'react';
import { useParams } from 'react-router-dom';
import { useFunnel } from '../context/FunnelContext';
import FunnelRoute from './FunnelRoute';
import LoaderInline from './LoaderInline';

const DynamicUpsellHandler = () => {
	const { upsell } = useParams();
	const { funnelData } = useFunnel();

	const upsellProducts = funnelData?.data?.upsellProducts || [];

	const matchedProduct = upsellProducts.find((p) => p.routeName === upsell);

	if (!matchedProduct) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<LoaderInline text="Loading Upsell Page Data..." />
			</div>
		);
	}

	return (
		<FunnelRoute
			componentName={matchedProduct.routeName?.charAt(0).toUpperCase() + matchedProduct.routeName?.slice(1)}
		/>
	);
};

export default DynamicUpsellHandler;
